<template>
	<div>
		<firstsceenimage :imgobj='bigimage'></firstsceenimage>
		<div ref="img1ref">
			<adword title="3D渲染，逼真还原设计" subtitle="高精建模+实时渲染，突破性的通过产品拟真方式展示材料运用与产品的效果，方便买卖双方直接查看应用效果和质感。
全过程应用三维、实时、动态的模型涵盖了几何信息、材料信息、结构信息、成本信息、各种组件的性质信息及制造信息的整合与联动。" slotheight="680">

				<div>
					<transition name="adfadey1">
						<img v-if="img1show" style="margin-top: 70px; width: 70%;" src="../../static/mbp.png">
					</transition>
				</div>
			</adword>
		</div>


		<adword title="为设计，更为设计师" :slotheight="halfimgrefH" class="marginbottom40">
			<div class="row" style="background-color: #F8F8F8; text-align: left;">


				<div class="col-sm-6" :style="halfimgrefHobj">
					<div style="padding-top: 15%;padding-left: 15%;padding-right: 25%;">
						<div style="font-size: 24px;font-weight: bold;letter-spacing: 6px;color:white;"> 让设计更加接近真实</div>
						<div
							style="margin-top: 26px;  color: #1D1F29;font-size: 12px;opacity: 0.5;letter-spacing: 3px;color:white;line-height: 18px;">
							将线上协同设计实时转换成为高清3D渲染图，或通过云端渲染生成4K棚拍级产品图，从此设计、配色、配料和推销无缝连接，让客户与设计师一起享受所见即所得。
						</div>
					</div>

				</div>

				<div style="background-repeat:no-repeat; background-position:right bottom ;" class="col-sm-6"
					:style="{backgroundImage: 'url('+backimg2+') ' }">
					<div style="padding: 15% 30% 0px 15%	;">
						<div style="font-size: 24px;font-weight: bold;letter-spacing: 6px;color: #1D1F29;"> 让作品直接链接市场
						</div>
						<div
							style="margin-top: 26px;; color: #1D1F29;font-size: 12px;opacity: 0.5;letter-spacing: 3px;line-height: 18px;">
							设计师作品通过AI数字版权保护平台进行知识产权保护；数字化订货交易系统为其提供直接且行之有效的实现其经济效益的途径。作品直接链接市场，直接产生效益。
						</div>
					</div>

				</div>
			</div>
		</adword>
		<div>
			<adword title="生态合作伙伴" slotheight="280" style=" background-color: #1D1F29;color: white;">
				<div class="container">
					<div class="row">
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/kizik.png" />
						</div>
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/奥康.png" />
						</div>
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/华为.png" />
						</div>
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/乐步.png" />
						</div>
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/欧文斯.png" />
						</div>
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/知衣.png" />
						</div>

					</div>
					<div style="height: 20px;"></div>
					<div class="row">
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/三体.png" />
						</div>
						<div class="col-md-2" style="height: 100px; ">
							<img style="height: 100px;background-color: wheat;" src="../../static/logo/易麦斯.png" />
						</div>



					</div>
				</div>
			</adword>
		</div>


	</div>
</template>
<script>
	import firstsceenimage from '../../components/firstsceenimage.vue'
	import adword from '../../components/adword.vue'
	import bigimage from '../../static/AI辅助设计平台.png'
	import adimage from '../../static/让设计更加接近真实.png'

	export default {
		name: 'Prodesgin',
		components: {
			firstsceenimage,
			adword,
			bigimage
		},
		data() {
			return {
				bigimage: bigimage,
				adimage: adimage,
				backimg: require('../../static/让设计更加接近真实.png'),
				backimg2: require('../../static/让作品直接链接市场水印.png'),

				img1reftop: 0,
				img1show: false,
				halfimgrefH: (window.screen.availWidth - 17) / 2 * 470 / 960,
				halfimgrefHobj: {

					backgroundImage: 'url(' + require('../../static/让设计更加接近真实.png') + ') ',
					height: (window.screen.availWidth - 17) / 2 * 470 / 960 + "px",
				}
			}
		},
		mounted() {

			window.addEventListener('scroll', this.scrollHandle); //绑定页面滚动事件

			if (window.innerWidth < 1000) {
				this.halfimgrefHobj.height ="100%"
			}
		},
		methods: {
			scrollHandle: function(e) {
				var _this = this
				this.scrolltop = e.srcElement.scrollingElement.scrollTop; // 获取页面滚动高度
				//实际高度太晚了，所以要加上一个虚拟高度
				this.vscrolltop = document.documentElement.clientHeight / 4 + this.scrolltop
				//显示4ad
				if (!this.img1show) {
					if (this.vscrolltop > this.img1reftop) {
						this.img1show = true;
					}
				}
			},
		}
	}
</script>

<style>
	.adfadey1-enter-active {
		transition: all 0.5s;
	}

	.adfadey1-enter {
		opacity: 0;
		transform: translateY(50px);
	}

	@media (max-width:999px) {}

	@media (min-width:1000px) {
		.marginbottom40 {
			margin-bottom: -40px;
		}
	}
</style>
